/**
 * Grid Cards – modal support
 *
 * Otwiera #productModal (taki sam jak w product-modal.js) po kliknięciu
 * w kartę, do której przypisano Product element z opcją "Pokaż okno modalne".
 */

function gridCardsModal() {
  // Check if #productModal exists now or might appear later
  // Use getElementById inside each function instead of closure to avoid stale reference

  window.openGridCardModal = function (id) {
    const modal = document.getElementById('productModal');
    if (!modal) return;

    const dataEl = document.querySelector(`[data-gc-modal="${id}"]`);
    if (!dataEl) return;

    const gallery     = dataEl.querySelector('.modal-gallery');
    const description = dataEl.querySelector('.modal-description');
    const additional  = dataEl.querySelector('.modal-additional');

    // Karta nadrzędna – pobierz obrazek i tytuł
    const card    = dataEl.closest('.grid-cards__card');
    const cardImg = card ? card.querySelector('img') : null;
    const title   = dataEl.dataset.gcTitle || '';

    // Tytuł
    const titleEl = document.getElementById('modal-title');
    if (titleEl) titleEl.textContent = title;

    // Główny obrazek
    const modalImage = document.getElementById('modal-image');
    if (modalImage && cardImg) {
      modalImage.src = cardImg.src;
      modalImage.alt = cardImg.alt;
      if (window.innerWidth >= 768) {
        modalImage.style.cursor = 'pointer';
        modalImage.onclick = () => {
          if (typeof window.openImageLightbox === 'function') {
            openImageLightbox(modalImage.src, modalImage.alt);
          }
        };
      }
    }

    // Opis
    const modalDesc = document.getElementById('modal-description');
    if (modalDesc) modalDesc.innerHTML = description ? description.innerHTML : '';

    // Dodatkowe elementy
    const modalAdd = document.getElementById('modal-additional-content');
    if (modalAdd) modalAdd.innerHTML = additional ? additional.innerHTML : '';

    // Miniatury
    const modalGallery = document.getElementById('modal-gallery');
    if (modalGallery) {
      modalGallery.innerHTML = '';

      if (cardImg) {
        modalGallery.appendChild(createThumb(cardImg.src, cardImg.alt, true));
      }

      if (gallery) {
        gallery.querySelectorAll('.gallery-item').forEach((item, i) => {
          if (i === 0) return; // pierwsza miniatura = główny obrazek karty
          const img = item.querySelector('img');
          if (img) modalGallery.appendChild(createThumb(img.src, img.alt || '', false));
        });
      }
    }

    // Otwórz modal
    modal.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  };

  // Zamknięcie – jeśli product-modal.js nie zdążył go zdefiniować
  if (typeof window.closeProductModal !== 'function') {
    window.closeProductModal = function () {
      const modal = document.getElementById('productModal');
      if (modal) modal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    };
  }

  // Zamknij klawiszem Escape
  document.addEventListener('keydown', (e) => {
    const modal = document.getElementById('productModal');
    if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) {
      window.closeProductModal();
    }
  });

  /** Tworzy miniaturę galerii (identyczna logika jak w product-modal.js) */
  function createThumb(src, alt, isActive) {
    const thumb = document.createElement('div');
    thumb.className = `aspect-square cursor-pointer overflow-hidden border ${
      isActive ? 'border-gray-500' : 'border-gray-50 hover:border-gray-300'
    }`;

    const img = document.createElement('img');
    img.src = src;
    img.alt = alt;
    img.className = 'w-full h-full object-cover';
    thumb.appendChild(img);

    thumb.addEventListener('click', () => {
      const mi = document.getElementById('modal-image');
      if (mi) {
        mi.src = src;
        mi.alt = alt;
        if (window.innerWidth >= 768 && typeof window.openImageLightbox === 'function') {
          mi.onclick = () => openImageLightbox(src, alt);
        }
      }
      // Aktualizuj aktywną miniaturę
      const mg = document.getElementById('modal-gallery');
      if (mg) {
        mg.querySelectorAll('div').forEach((t) => {
          t.className = t.className
            .replace('border-gray-500', 'border-gray-50 hover:border-gray-300');
        });
      }
      thumb.className = thumb.className.replace(
        'border-gray-50 hover:border-gray-300',
        'border-gray-500'
      );
    });

    return thumb;
  }
}

document.addEventListener('DOMContentLoaded', gridCardsModal);
